import OldWidgetsModule from '@abaco/widgets-container-module/src/modules/old-widgets';
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import { AbacoWebModule, ApplicationReadyEvent } from '@abaco/web-common/src/app';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import NumberUtils from "@abaco/web-components/src/components/input/NumberUtils"
import { HA_UNIT } from "../../modules/crop-plan-module/api/utils";
import Vue from "vue";

import myRoutes from "./routes";
import CropPlanModule from '../crop-plan-module';

export const MODULE_ID = "print_crop_plan_module";

export default class PrintCropPlanModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly forceTopLevelRoutes = true;

    private oldModule!: OldWidgetsModule;
    private ssoModule!: SSOModule;
    private created = false;
    private http!: HTTPClient;

    dependsOn = {
        [OldWidgetsModule.MODULE_ID]: () => new OldWidgetsModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule()
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        Vue.filter("TO_AREA_HA", (val: number, fromFormat?: string) => {
            if (fromFormat === HA_UNIT) {
                return NumberUtils.stringify(val, 4)
            }
            return NumberUtils.stringify(val / 10000, 4)
        })
        const oldModule = evt.modules.find(m => m.id === OldWidgetsModule.MODULE_ID) as OldWidgetsModule;
        const ssoModule = evt.modules.find(m => m.id === SSOModule.MODULE_ID) as SSOModule;
        if (!oldModule) {
            throw new Error("Old widgets module not found");
        }
        this.oldModule = oldModule;
        this.ssoModule = ssoModule;
        this.http = evt.http;
    }

    public async getWidgetParams(groupCode: string, widgetCode: string) {
        const url = "/siticatasto/dbgis-servlet/tl_data?svccode=indexes/indexes_get_group_widget_by_code"
        const params = {
            group_code: groupCode,
            wcode: widgetCode,
            lang: this.ssoModule.vuexModule.user?.locale
        }
        const res = await this.http.get(url, { params });
        return res.data.services[0].entities[0];
    }
}
